import { useContext } from "react";
import { LocalizationContext } from "../context/LocalizationContext";
import { Translations } from "../localization/Translations";

const useTranslations: () => Translations = () => useContext(LocalizationContext);

export default useTranslations;
